import { ValidatorConstraint, ValidatorConstraintInterface } from "class-validator";
import { Policy } from "../Policy";

@ValidatorConstraint({
    name: "StatusValidator",
    async: false,
})
export class StatusValidator implements ValidatorConstraintInterface {
    validate(value: string): boolean {
        return (Object.values(Policy.Status) as string[]).includes(value);
    }

    defaultMessage(): string {
        return "$property is invalid";
    }
}
